// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__moMSA","collapsed":"Navigation_collapsed__Ezv+L","active":"Navigation_active__Ir1dY","icon":"Navigation_icon__8UbfO"};